import React from 'react'
import { Provider } from '../../../services/likeContext'
import PageTransition from '../components/PageTransition/PageTransition'
import Stack from '../components/Stack/Stack'
import * as s from './Jobs.styles'

function Jobs() {
  return (
    <PageTransition>
      <Provider>
        <s.JobsPage>
          <Stack />
        </s.JobsPage>
      </Provider>
    </PageTransition>
  )
}

export default Jobs
